var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('div',{staticClass:"form-row"},_vm._l((_vm.filterFields),function(field){return (!field.hidden && _vm.current[field.name])?_c('div',{staticClass:"col-4"},[_c('b',[_vm._v(_vm._s(_vm.tr(field.label))+":")]),_vm._v(" "),_c('i',[_vm._v(_vm._s(_vm.getFilterValue(field)))])]):_vm._e()}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }